import { NullableElement } from '../types/exposedTypes'

export function getActiveElement() {
  return document.activeElement as NullableElement
}
